import React, { useRef, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../../atoms/icon/icon.js';
import { backIcon, closeIcon } from './assets/icons.js';

const Popover = ({ isOpen, children, insertNode, width, closeOnBackdropClick, renderTitle, renderCloseButton, renderBackButton, renderTopOverlay, onCloseButtonClick, onBackButtonClick, centered = false, style = {} }) => {
    const dialogRef = useRef(null);
    useEffect(() => {
        if (isOpen)
            hideBodyScroll();
        isOpen ? dialogRef.current?.showModal() : dialogRef.current?.close();
    }, [isOpen]);
    const hideBodyScroll = () => {
        const invisibleScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty("--invisible-scrollbar-width", `${invisibleScrollbarWidth}px`);
        document.body.style.setProperty("overflow", "hidden", "important");
        document.body.style.setProperty("-webkit-overflow-scrolling", "touch");
    };
    const handleBackdropClick = useCallback((e) => {
        if (!e.currentTarget.matches("dialog"))
            return;
        const { top, bottom, left, right } = e.currentTarget.getBoundingClientRect();
        const { clientX: mouseX, clientY: mouseY } = e;
        if (mouseX === 0 && mouseY === 0)
            return;
        const clickedOutsideOfModalBox = (mouseX <= left || mouseX >= right ||
            mouseY <= top || mouseY >= bottom);
        if (clickedOutsideOfModalBox)
            dialogRef.current?.close();
    }, [dialogRef]);
    const prepareBackButton = () => {
        if (renderBackButton)
            return renderBackButton();
        if (!onBackButtonClick)
            return null;
        return (React.createElement("div", { className: "mbw-popover-back-btn-container", "data-testid": "mbw-popover-back-btn-container" },
            React.createElement("button", { "aria-label": "back", className: "mbw-popover-back-btn", onClick: onBackButtonClick },
                React.createElement(Icon, null, backIcon))));
    };
    const prepareCloseButton = () => {
        if (renderCloseButton)
            return renderCloseButton();
        if (!onCloseButtonClick)
            return null;
        return (React.createElement("div", { className: "mbw-popover-close-btn-container", "data-testid": "mbw-popover-close-btn-container" },
            React.createElement("button", { "aria-label": "close", className: "mbw-popover-close-btn", onClick: onCloseButtonClick },
                React.createElement(Icon, null, closeIcon))));
    };
    return (React.createElement(React.Fragment, null, createPortal(React.createElement("dialog", { ref: dialogRef, onClick: closeOnBackdropClick ? handleBackdropClick : undefined, className: `mbw-popover-dialog ${centered ? "centered" : ""}`, "data-testid": "mbw-popover-dialog", style: { "--mbw-popover-width": width, ...style } },
        renderTopOverlay && (React.createElement("div", { className: "mbw-popover-top-overlay-container", "data-testid": "mbw-popover-top-overlay-container" }, renderTopOverlay())),
        prepareCloseButton(),
        React.createElement("div", { className: "mbw-popover-title-container", "data-testid": "mbw-popover-title-container" },
            prepareBackButton(),
            React.createElement("div", { className: "mbw-popover-title", "data-testid": "mbw-popover-title" }, renderTitle())),
        React.createElement("div", { className: "mbw-popover-content", "data-testid": "mbw-popover-content" }, children)), insertNode || document.body)));
};

export { Popover as default };
//# sourceMappingURL=popover.js.map
